import React from 'react';
import PropTypes from 'prop-types';
import Spinner from 'components/Spinner';
import InvalidToken from './components/InvalidToken';
import UnknownError from './components/UnknownError';

const TOKEN_ERRORS = {
    TOKEN_EXPIRED: 'TOKEN_EXPIRED',
    INVALID_TOKEN: 'INVALID_TOKEN'
};

export class ValidateResetPasswordToken extends React.Component {
    static propTypes = {
        validateToken: PropTypes.func.isRequired,
        loading: PropTypes.bool,
        error: PropTypes.any,
        token: PropTypes.string.isRequired,
        onValidToken: PropTypes.func
    };

    state = {
        tokenError: null
    };

    static defaultProps = {
        onValidToken: () => undefined
    };

    componentDidMount() {
        this.props.validateToken(this.props.token).then(({data: {validateResetPasswordToken}}) => {

            if (validateResetPasswordToken.ok) {
                this.props.onValidToken(validateResetPasswordToken);
            }
            else {
                this.setState({
                    tokenError: validateResetPasswordToken.errorMessage
                });
            }
        }).catch(() => {
            this.setState({tokenError: 'INVALID_TOKEN'});
        });
    }

    renderTokenError = () => {
        const {tokenError} = this.state;

        if (tokenError === TOKEN_ERRORS.INVALID_TOKEN || tokenError === TOKEN_ERRORS.TOKEN_EXPIRED) {
            return <InvalidToken/>;
        }

        return <UnknownError/>;
    };

    render() {
        if (this.props.loading) {
            return <Spinner/>;
        }

        // Server error
        if (this.props.error) {
            console.error(this.props.error);

            return <UnknownError/>;
        }

        if (this.state.tokenError) {
            return this.renderTokenError();
        }

        // This should never happen
        return null;
    }
}

export default ValidateResetPasswordToken;
